// SPDX-License-Identifier: AGPL-3.0-or-later

// Micup: the in-app picker has no system dialog to cancel, so a pick that does not start a share is a failure.
export class ScreenShareSourceNotStartedError extends Error {
	readonly sourceId: string;

	constructor(sourceId: string) {
		super(`Screen share did not start for picked source ${sourceId}`);
		this.name = 'ScreenShareSourceNotStartedError';
		this.sourceId = sourceId;
	}
}

export function isScreenShareSourceNotStartedError(error: unknown): error is ScreenShareSourceNotStartedError {
	return error instanceof ScreenShareSourceNotStartedError;
}
